   <div class="fdx-c-modal__body" aria-live="polite">
      <div class="fdx-u-align--center">
        <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--8 fdx-u-mt--1@small">
          <h1 class="fdx-c-header fdx-c-header--h3 fdx-u-pr--5@medium fdx-u-pl--7@medium"
              id="twoFaTogglePopupTitle">
              {{ 'twoFaTogglePopup.Title' | translate}} 
          </h1>
        </div>
      </div>
      <div class="fdx-u-align--center">
        <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--8 fdx-u-ml--8">
              <span class="fdx-c-paragraph fdx-u-pr--5@medium fdx-u-pl--5@medium"
                    id="twoFaTogglePopupMessage">
                    {{ 'twoFaTogglePopup.Message' | translate}} 
              </span>
        </div>
      </div>
  
      <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--7 fdx-u-ml--3 fdx-u-mr--3">
        <button id="setupnow-btn"
                class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--responsive"
                aria-atomic="true" wlgn-wproautofocus (click)="continueClicked()">
                {{ 'twoFaTogglePopup.continueBtn' | translate }}
        </button>
      </div>
      <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--4">
        <button id="later-btn"
                class="fdx-c-button fdx-c-button--suffix fdx-c-button--text fdx-c-button--responsive fdx-u-cursor--pointer fdx-u-align--center"
                aria-atomic="true" (click)="closePopup()">
                {{'twoFaTogglePopup.cancelBtn' | translate }}
            </button>
      </div>
    </div>
  
                                                                       